import React, { useContext } from 'react'

import { Grid, Header, Divider } from 'semantic-ui-react'

import { UserContext } from '../../contexts/UserContext'

import Section from '../../components/common/Section'
import SubSection from '../../components/common/SubSection'
import Title from '../../components/common/Title'

import ConnectedPlatforms from './ConnectedPlatforms'
import CloudStorage from './CloudStorage'
import VloggApi from './VloggApi'
import Marketplaces from './Marketplaces'

const MyIntegrationsPage = () => {
  const { userProfile } = useContext(UserContext)
  
  // Is user collaborator
  const isUserCollaborator = (): boolean => {
    return userProfile.userAccessRights === 'collaborator'
  }
  
  console.log('Rendering Integrations page')
  
  return (
    <Section>
      <>
        <Title title="" />

        <SubSection>
          <>
            <Header as="h1" style={{ fontWeight: 'bold' }}>
              Integrations
              <Header.Subheader>
                Connect Vloggi with other platforms via APIs and webhooks.
              </Header.Subheader>
            </Header>

            <Divider style={{ margin: '2rem 0' }} />

            {isUserCollaborator() ? (
              <Header as="h3">Only admin member can manage team account.</Header>
            ) : (
              <Grid columns={1} divided="vertically">
                <Grid.Row stretched>
                  <Grid.Column>
                    <ConnectedPlatforms />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row stretched>
                  <Grid.Column>
                    <CloudStorage />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row stretched>
                  <Grid.Column>
                    <VloggApi />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row stretched>
                  <Grid.Column>
                    <Marketplaces />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </>
        </SubSection>
      </>
    </Section>
  )
}

export default MyIntegrationsPage
